module.exports = __webpack_public_path__ + "img/img12.0b27c5fb.png";